import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import * as DropdownMenu from '@radix-ui/react-dropdown-menu'







export const Menu = ({trigger, className, children, ...props}) => {
  return (
    _jsxs(DropdownMenu.Root, { ...props, children: [
      _jsx(DropdownMenu.Trigger, { asChild: true, children: trigger})
      , _jsx(DropdownMenu.Portal, { children: children})
    ]})
  )
}
